import inMemoryJWT from "../auth/inMemoryJwt"
import { urlServer } from "../config/GlobalConstant"
import { CLEAR_CITIES, CLEAR_COUNTRIES, CLEAR_STATES, GET_CITIES, GET_COUNTRIES, GET_STATES } from "./types"

export const getCountries = () => async dispatch =>  {
    await fetch(`${urlServer}locations/get-countries`, {
        method: 'POST',
        mode: 'cors', 
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({type:GET_COUNTRIES,payload:respJson.data})
        }).catch(()=>{})
}
export const getStates = (countryID) => async dispatch =>  {
    await fetch(`${urlServer}static-routes/locations/get-states`, {
        method: 'POST',
        mode: 'cors', 
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({countryID})
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({type:GET_STATES,payload:respJson.data})
        })
}

export const getCities = (stateID) => async dispatch =>  {
    await fetch(`${urlServer}static-routes/locations/get-cities`, {
        method: 'POST',
        mode: 'cors', 
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({stateID})
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({type:GET_CITIES,payload:respJson.data})
        })
}
export const clearCountries = () =>  dispatch =>  {
    dispatch({type:CLEAR_COUNTRIES})
}
export const clearStates = () =>  dispatch =>  {
    dispatch({type:CLEAR_STATES})
}

export const clearCities = () =>  dispatch =>  {
    dispatch({type:CLEAR_CITIES})
}
